/* eslint-disable filename-rules/match -- versioned style-config files are named after the DLS version */
import type { ComponentStyleConfig } from '@chakra-ui/theme';

export const styleConfig: ComponentStyleConfig = {
  baseStyle: {
    fontWeight: 'normal',
    color: 'neutral.fg-primary',
  },
  // TODO: remove prefixes for letter spacing
  sizes: {
    'body-xxl': {
      fontSize: ['3xl', '4xl'],
      lineHeight: ['2.25rem', '2.5rem'], // TODO: Need a clarification on the mobile line height
      letterSpacing: 'less-tight',
    },
    'body-xl': {
      fontSize: '2xl',
      lineHeight: '2rem',
      letterSpacing: 'tight',
    },
    'body-lg': {
      fontSize: 'lg',
      lineHeight: '1.5rem',
      letterSpacing: 'tight',
    },
    'body-md': {
      fontSize: 'md',
      lineHeight: '1.5rem',
      letterSpacing: 'less-tight',
    },
    'body-sm-md': {
      fontSize: 'sm-md',
      lineHeight: '1.4rem',
      letterSpacing: 'less-tight',
    },
    'body-sm': {
      fontSize: 'sm',
      lineHeight: '1rem',
      letterSpacing: 'less-tight',
    },
    'body-xs': {
      fontSize: 'xs',
      lineHeight: '1rem',
    },
  },
  variants: {
    'text-primary': {
      color: 'neutral.fg-primary',
    },
    'text-secondary': {
      color: 'neutral.fg-secondary',
    },
    'text-tertiary': {
      color: 'neutral.fg-tertiary',
    },
    'text-disabled': {
      color: 'neutral.fg-disabled',
    },
  },
  defaultProps: {
    size: 'body-md',
    variant: 'text-primary',
  },
};
